export default __webpack_public_path__ + "static/media/estado-30.60e2bcc7.svg";